export default function GoaffproLogo({size}:{size: number}){
    return  <img src={'/icon-square.svg'}
    alt="Goaffpro logo"
    className="rounded overflow-hidden" 
        style={{width:size, height:size}}
    />
}